// Simmons's undergraduate majors (#2748). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Course Catalog, "Programs of Study" list.
// Simmons publishes its catalog on simmons.smartcatalogiq.com, which is not
// an .edu host, so each group cites the simmons.edu Course Catalog page that
// links the 2026-2027 Undergraduate Catalog. Kept: every bachelor's major in
// the list, with the catalog's degree abbreviation (BA, BS, BSBA, BSN, BSW;
// Interaction Design and Web Development is listed "BA or BS" and appears
// once per degree). Left out: certificates, the minor, accelerated
// bachelor's-master's and 4+3/4+2/4+1/3+1 programs, online degree-completion
// programs, the Biology Environmental Science Track and the Political Science
// International Relations Concentration (tracks of majors listed here), and
// the Engineering Dual Degree Program (completed with a partner school).
// "Women's" is written with a straight apostrophe. "Data Science and AI" is
// the catalog's official program name. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    slug: 'simmons-university',
    read: '2026-10-01',
    intro: 'Every bachelor\'s degree major in Simmons\'s official 2026-2027 Undergraduate Course Catalog, with the degree it leads to. Minors, certificates, combined bachelor\'s-master\'s programs and online degree-completion programs are left out.',
    groups: [
        {
            name: 'Majors',
            source: {
                label: 'Simmons University Course Catalog (2026-2027 Undergraduate Catalog, Programs of Study)',
                url: 'https://www.simmons.edu/academics/course-catalog',
            },
            majors: [
                { name: 'Accounting', degree: 'BSBA' },
                { name: 'Africana Studies', degree: 'BA' },
                { name: 'Biochemistry', degree: 'BS' },
                { name: 'Biology', degree: 'BS' },
                { name: 'Business & Management', degree: 'BSBA' },
                { name: 'Chemistry', degree: 'BS' },
                { name: 'Communications', degree: 'BA' },
                { name: 'Computer Science', degree: 'BS' },
                { name: 'Data Science and AI', degree: 'BS' },
                { name: 'Economics', degree: 'BA' },
                { name: 'Finance', degree: 'BSBA' },
                { name: 'Health and Exercise Science', degree: 'BS' },
                { name: 'History', degree: 'BA' },
                { name: 'Information Technology and Cybersecurity', degree: 'BS' },
                { name: 'Interaction Design and Web Development', degree: 'BA' },
                { name: 'Interaction Design and Web Development', degree: 'BS' },
                { name: 'Literature', degree: 'BA' },
                { name: 'Marketing', degree: 'BSBA' },
                { name: 'Mathematical Sciences', degree: 'BS' },
                { name: 'Neuroscience and Behavior', degree: 'BS' },
                { name: 'Nursing', degree: 'BSN' },
                { name: 'Nutrition and Dietetics', degree: 'BS' },
                { name: 'Nutrition and Wellness', degree: 'BS' },
                { name: 'Physics', degree: 'BS' },
                { name: 'Political Science', degree: 'BA' },
                { name: 'Psychology', degree: 'BA' },
                { name: 'Public Health', degree: 'BS' },
                { name: 'Public Relations and Marketing Communications', degree: 'BA' },
                { name: 'Retail Management; the Prince Program in Retail Management', degree: 'BSBA' },
                { name: 'Social Work', degree: 'BSW' },
                { name: 'Sociology', degree: 'BA' },
                { name: 'Women\'s, Gender, and Sexuality Studies', degree: 'BA' },
                { name: 'Writing', degree: 'BA' },
            ],
        },
    ],
};

export default majors;
